export function PersonalDataModel() {
    const model = {
        hasChildren: true,
        familyStatus: {
            show: true,
            required: false,
            custom: false,
            saveCustom: false,
            variants: [],
        },
    };

    return {
        data: model,
        update(fieldData) {
            if (!fieldData) return;
            const data = fieldData.personalData;
            if (!data) return;

            model.hasChildren = data.hasChildren;

            ["show", "required", "custom", "saveCustom"].forEach((key) => {
                model.familyStatus[key] = data.familyStatus[key];
            });
        },
        reset() {
            model.hasChildren = true;
            model.familyStatus.show = true;

            ["required", "custom", "saveCustom"].forEach((key) => {
                model.familyStatus[key] = false;
            });
        },
        setDictionaries(dictionaries) {
            const { familyStatuses } = dictionaries;

            if (familyStatuses) model.familyStatus.variants = familyStatuses;
        },
        getDictionaries() {
            const { familyStatus } = model;
            return {
                familyStatuses: familyStatus.variants,
            };
        },
        getData() {
            return {
                personalData: model,
            };
        },
    };
}
